import TabType2 from "./tabType2";

export default TabType2;
